import { defaultState } from './defaultState';

type State = typeof defaultState;

export const reducers = {
  clear: () => defaultState,
  promotionLoaded: (state: State, payload: string) => ({
    ...state,
    isLoading: false,
    data: payload,
    hasPreloaded: true
  }),
  promotionLoadFailed: (state: State) => ({
    ...state,
    isLoading: false,
    hasErrored: true
  })
};
